import React, { useState, useEffect, useContext, createContext, useMemo, } from 'react';
const ContentContext = createContext({
    content: undefined,
});
export function ContentContextProvider({ children, contentService, }) {
    const [content, setContent] = useState(contentService.getContent());
    useEffect(() => {
        const listener = () => {
            setContent(contentService.getContent());
        };
        contentService.onContentChange(listener);
        return () => {
            contentService.removeOnContentChange(listener);
        };
    }, [contentService]);
    const value = useMemo(() => ({ content }), [content]);
    return React.createElement(ContentContext.Provider, { value: value }, children);
}
export function useContent() {
    const { content } = useContext(ContentContext);
    return content !== undefined ? content : undefined;
}
//# sourceMappingURL=index.js.map